import React from 'react';
import { Text } from '@antimatterhq/ui/components/typography';

// Field component
const FieldsetField = ({ children }: React.PropsWithChildren) => {
  return <div className="flex gap-1">{children}</div>;
};

// Label component for Field
const FieldsetLabel = ({ children }: React.PropsWithChildren) => {
  return (
    <Text
      bold
      color="secondary"
      className="group-[.fieldset-list]:font-normal group-[.fieldset-list]:text-grey-500/80 group-[.fieldset-list]:dark:text-grey-350/80"
    >
      {children}
    </Text>
  );
};

// Value component for Field
const FieldsetValue = ({ children }: React.PropsWithChildren) => {
  return <Text color="secondary">{children}</Text>;
};

// list component
const FieldsetList = ({ children }: React.PropsWithChildren) => {
  return <div className="fieldset-list group">{children}</div>;
};

// Nesting the components under Fieldset
export const Fieldset = {
  Field: FieldsetField,
  Label: FieldsetLabel,
  Value: FieldsetValue,
  List: FieldsetList,
};
